import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import Swal from 'sweetalert2';
import { getDatabase, onChildAdded, onChildChanged, onChildRemoved, onValue, ref, set } from "firebase/database";
import { BehaviorSubject } from 'rxjs';
import { CustomizationStoreService } from './customization.store.service';
import { getDefaultStatusIconDataUri, STATUS_ICON_DEFAULTS, StatusIconType } from 'src/app/shared/icons/status-icons';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    _userNotifications: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    countNotifications = 0;
    public userID = '123';

    constructor(public snackBar: MatSnackBar, public customizationStore: CustomizationStoreService) {

    }

    public showToast(mssg, duration?, type?) {
        this.snackBar.open(mssg || 'I\'m a notification!', 'Close', {
          duration: duration || 4000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: type || ''
        });
    }

    public showAlert(title, mssg?, icon?, objActions?) {
          let obj = {
            title: title,
            text: mssg || '',
            showCancelButton: objActions ? true : false,
            confirmButtonText: objActions && objActions.okButtonLabel ? objActions.okButtonLabel : 'OK',
            cancelButtonText: objActions && objActions.cancelButtonLabel ? objActions.cancelButtonLabel : '',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
          }
          const requestedIcon = icon;
          if(this.customizationStore.FUNDER_STYLES) {
            icon = this.getIconFromString(icon)
          }
          // Iconografía Material Design por defecto; solo se sustituye si el funder ha cargado una imagen para ese caso.
          const defaultIconUri = getDefaultStatusIconDataUri(this.toStatusIconType(this.isIcon(icon) ? icon : requestedIcon));
          if(this.isIcon(icon)) {
            obj['imageUrl'] = defaultIconUri;
            obj['imageWidth'] = 72;
            obj['imageHeight'] = 72;
            obj['imageAlt'] = '';
          } else {
            obj['imageUrl'] = icon;
            // Si la imagen del funder no carga, se muestra el icono por defecto (nunca un hueco en blanco)
            obj['didOpen'] = () => {
              const image = Swal.getImage() as HTMLImageElement;
              if (image) {
                const useDefault = () => {
                  image.onerror = null;
                  image.src = defaultIconUri;
                  image.width = 72;
                  image.height = 72;
                };
                image.onerror = useDefault;
                if (image.complete && image.naturalWidth === 0) {
                  useDefault();
                }
              }
            };
          }
          Swal.fire(obj).then((result) => {
            if (result.value) {
              if(objActions && objActions.okAction) {
                objActions.okAction();
              }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              if(objActions && objActions.cancelAction) {
                objActions.cancelAction();
              }
            }
          });

    }

    getIconFromString(icon) {
      if(!icon || !this.customizationStore || !this.customizationStore.FUNDER_STYLES) return 'error';
      if(icon == 'success') {
        return this.customizationStore.FUNDER_STYLES.successIcon || icon;
      }
      if(icon == 'error') {
        return this.customizationStore.FUNDER_STYLES.errorIcon || icon;
      }
      if(icon == 'warning') {
        return this.customizationStore.FUNDER_STYLES.warningIcon || icon;
      }
      if(icon == 'info') {
        return this.customizationStore.FUNDER_STYLES.infoIcon || icon;
      }
      return icon;
    }

    private toStatusIconType(icon): StatusIconType {
      return icon && icon in STATUS_ICON_DEFAULTS ? icon : 'info';
    }

    isIcon(icon) {
      if(!icon) {return true}
      return icon == 'success' || icon == 'error' || icon == 'warning' || icon == 'info' || icon == 'question'
    }

    public showPrompt(mssg) {
      return new Promise((resolve, reject) => {
        Swal.fire({
          title: mssg,
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Enviar',
          allowOutsideClick: true
        }).then((result) => {
          if (result.isConfirmed) {
            resolve(result.value)
          } else {
            reject(false)
          }
        })
      })

    }

    public openDialog(data: { title: string; message: string }) {
      Swal.fire({
        title: data.title,
        text: data.message
      });
    }

    bindFunderNotifications(userID) {
      this.userID = userID;
      const db = getDatabase();
      const starCountRef = ref(db,  `notifications/${userID}`);
      onValue(starCountRef, (snapshot) => {
        let n = snapshot.val();
        let r = n ? this.convertObjectArrayToArray(n) : [];
        if(n && this.countNotifications < r.length) {
          this.showToast('Nueva notificacion', 5000, 'info')
        }
        this.countNotifications = +(r.length);
        this._userNotifications.next(r && r.length ? r.sort((a,b) => this.sortByDate(a,b)) : []);
      });
    }

  sortByDate(a,b) {
    return +(new Date(a.date).getTime()) - +(new Date(b.date).getTime());
  }

  convertObjectArrayToArray(obj: any ) {
    return Object.keys(obj).map(key => {
      const ar = obj[key];
      ar['key'] = key;
      return ar;
    });
  }

  parseNotificationMap(obj) {

  }

  subscribeMyNotifications() {
      return this._userNotifications.asObservable();
  }

  markAsReaded(notificationID) {
    const db = getDatabase();
    set(ref(db, `notifications/${this.userID}/${notificationID}/readed`), true);
  }

  deleteNotification(notificationID) {
    const db = getDatabase();
    set(ref(db, `notifications/${this.userID}/${notificationID}`), null).then(d => {
      this.showToast('Notificación eliminada', 4000, 'danger');
    })
  }
}



